module.exports = __webpack_public_path__ + "static/chrome-9a3a64d9c6e4d676ccdbd6f285568307.png";